import React from 'react';
import { Row, Col } from 'bee-layout';

require('bee-layout/build/Layout.css');

const functionList = {
    '#month(0)#': '本月',
    '#day(0)#': '今日',
};
let resultValue = [];
let COUNT = 0;
function selectDateFunction(e, callback, item) {
    resultValue.push(item);
    COUNT++;
    if (COUNT === 2) {
        pickerState(e, false);
        callback(resultValue);
        resultValue = [];
        COUNT = 0;
    }
}
function pickerState(e, flag) {
    let pickerDOM = document.getElementsByClassName('rc-calendar-picker')[0];
    if (pickerDOM) {
        pickerDOM.style.display = flag ? 'block' : 'none';
    }
}

export const checkFuntionValue = value => {
    document.getElementsByClassName('rc-calendar-picker')[0];
    if (value && value[0] && value[1]) { return Object.keys(functionList).indexOf(value[0]) !== -1 && Object.keys(functionList).indexOf(value[1]) !== -1; }

};
export const getTimeFunctionLabel = (value, show) => {
    let startLabel = functionList[value[0]] || '';
    let endLabel = functionList[value[1]] || '';
    return show && startLabel && endLabel ? (
        <div
            className="date-picker-mask"
            onClick={e => {
                let $this = e.target || e.currentTarget;
                let $input = $this && $this.parentElement.querySelector('input');
                $input.click();
                // pickerState 逻辑根本没有执行
                return pickerState(e, true);
            }}
        >
            {startLabel + '~' + endLabel}
        </div>
    ) : null;
};
// value = 选择的时间 callback = 单击回调 show  = 是否显示时间函数
export const getDateFunNode = (value, callback, show) => {
    if (!show) return;
    let spen = 4;
    resultValue = [];
    COUNT = 0;
    return (
        <HotKeys
            keyMap={{
                rightHandler: ["right"],
                leftHandler: ["left"],
                enterHander: ["enter"],
            }}
            handlers={{
                rightHandler: () => {
                    if (document.activeElement.nextElementSibling) {
                        document.activeElement.nextElementSibling.focus();
                    }
                },
                leftHandler: () => {
                    if (document.activeElement.previousElementSibling) {
                        document.activeElement.previousElementSibling.focus();
                    }
                },
                enterHander: () => {
                    if (document.activeElement) {
                        document.activeElement.click();
                    }
                },
            }}
            clearOpenPanel={false}
        >
            <Row>
                {Object.keys(functionList).map((item, index) => (
                    <Col
                        tabindex="0"
                        className="fun-plan-area"
                        lg={spen}
                        md={spen}
                        sm={spen}
                        xs={spen}
                        onClick={e => selectDateFunction(e, callback, item)}
                        onKeyDown={e => {
                            if(e.keyCode !== 27){
                                e.stopPropagation();
                            }
                        }}
                    >
                        <span>{functionList[item]}</span>
                    </Col>
                ))}
            </Row>
        </HotKeys>
    );
};
